export const menuItemsData = [
    {
    title: "PLATFORM CORE",
    submenu: [
	  {
    title: "01 SYSTEM ADMIN PLATFORM ADMIN",
    submenu: [
	      {
        title: "Stark RWAE Exchange - USA Platform Profile",
        url: "/Platform_USA_Profile",
      }
,      {
        title: "Core Token Type Definition",
        url: "/Core_Token_Type_Definition",
      }
,      {
        title: "Core Token Economic Model Master",
        url: "/Core_Token_Economic_Model_Master",
      }
,      {
        title: "Risk Color Matrix",
        url: "/Core_Risk_Color_Matrix",
      }
,      {
        title: "Platform Module Configuration",
        url: "/Platform_Module_Config",
      }
,      {
        title: "Workflow Definition",
        url: "/Workflow_Definition",
      }
,      {
        title: "Workflow Step Definition",
        url: "/Workflow_Step_Definition",
      }
,      {
        title: "User Account",
        url: "/User_Account",
      }
,      {
        title: "Role Definition",
        url: "/Role_Definition",
      }
,      {
        title: "User Role Assignment",
        url: "/User_Role_Assignment",
      }
,      {
        title: "System Code List",
        url: "/System_Code_List",
      }

	]
  }
,  {
    title: "02 ORGANIZATION STAKEHOLDER ONBOARDING",
    submenu: [
	      {
        title: "Organization Profile",
        url: "/Organization_Profile",
      }
,      {
        title: "Stakeholder Profile",
        url: "/Stakeholder_Profile",
      }

	]
  }
,  {
    title: "03 INVESTOR ONBOARDING COMPLIANCE",
    submenu: [
	      {
        title: "Investor Profile",
        url: "/Investor_Profile",
      }
,      {
        title: "Investor KYC AML Check",
        url: "/Investor_KYC_AML_Check",
      }
,      {
        title: "Investor Accreditation Verification",
        url: "/Investor_Accreditation_Verification",
      }
,      {
        title: "Investor Bank Account",
        url: "/Investor_Bank_Account",
      }
,      {
        title: "Investor Risk Acknowledgment",
        url: "/Investor_Risk_Acknowledgment",
      }

	]
  }
,  {
    title: "04 ASSET SPV DUE DILIGENCE LEGAL",
    submenu: [
	      {
        title: "Core Data Room",
        url: "/Core_Data_Room",
      }
,      {
        title: "Core Data Room Document",
        url: "/Core_Data_Room_Document",
      }
,      {
        title: "Core Document Verification",
        url: "/Core_Document_Verification",
      }
,      {
        title: "Core Title Search Report",
        url: "/Core_Title_Search_Report",
      }
,      {
        title: "Core Appraisal Report",
        url: "/Core_Appraisal_Report",
      }
,      {
        title: "Core Due Diligence Checklist",
        url: "/Core_Due_Diligence_Checklist",
      }
,      {
        title: "Core Project SPV",
        url: "/Core_Project_SPV",
      }
,      {
        title: "Core Legal Opinion",
        url: "/Core_Legal_Opinion",
      }

	]
  }
,  {
    title: "05 ESCROW INVESTOR PROTECTION MARKET",
    submenu: [
	      {
        title: "Core Escrow Account",
        url: "/Core_Escrow_Account",
      }
,      {
        title: "Core Investor Protection Profile",
        url: "/Core_Investor_Protection_Profile",
      }
,      {
        title: "Core Secondary Market Config",
        url: "/Core_Secondary_Market_Config",
      }
,      {
        title: "Core Governance Rule Set",
        url: "/Core_Governance_Rule_Set",
      }

	]
  }
,  {
    title: "06 CORE OPERATIONS AUDIT REPORTING",
    submenu: [
	      {
        title: "Workflow Instance",
        url: "/Workflow_Instance",
      }
,      {
        title: "Core Audit Log",
        url: "/Core_Audit_Log",
      }
,      {
        title: "Core Notification",
        url: "/Core_Notification",
      }
,      {
        title: "Core Escrow Release Request",
        url: "/Core_Escrow_Release_Request",
      }
,      {
        title: "Core Tax Reporting Package",
        url: "/Core_Tax_Reporting_Package",
      }
,      {
        title: "Core Platform Dashboard",
        url: "/Core_Platform_Dashboard",
      }

	]
  }

	]
  }
,  {
    title: "RENT INCOME",
    submenu: [
	  {
    title: "01 ASSET OWNER SPONSOR ASSET SETUP",
    submenu: [
	      {
        title: "Rental Income Asset Profile",
        url: "/RENT_Asset_Profile",
      }
,      {
        title: "Rental Income Property Management Agreement",
        url: "/RENT_Property_Management_Agreement",
      }
,      {
        title: "Rental Income Unit Profile",
        url: "/RENT_Unit_Profile",
      }

	]
  }
,  {
    title: "02 OFFERING LEGAL COMPLIANCE READINESS",
    submenu: [
	      {
        title: "Rental Income Token Offering",
        url: "/RENT_Token_Offering",
      }
,      {
        title: "Rental Income Token Token Class",
        url: "/RENT_Token_Class",
      }
,      {
        title: "Rental Income Token Token Economics",
        url: "/RENT_Token_Economics",
      }
,      {
        title: "Rental Income Token Legal Rights Matrix",
        url: "/RENT_Legal_Rights_Matrix",
      }
,      {
        title: "Rental Income Token Risk Score",
        url: "/RENT_Risk_Score",
      }

	]
  }
,  {
    title: "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
    submenu: [
	      {
        title: "Rental Income Token Subscription Order",
        url: "/RENT_Subscription_Order",
      }
,      {
        title: "Rental Income Token Token Ledger",
        url: "/RENT_Token_Ledger",
      }

	]
  }
,  {
    title: "04 PROPERTY MANAGER RENTAL OPERATIONS",
    submenu: [
	      {
        title: "Rental Income Token Independent Inspection Report",
        url: "/RENT_Independent_Inspection_Report",
      }
,      {
        title: "Rental Income Lease Record",
        url: "/RENT_Lease_Record",
      }
,      {
        title: "Rental Income Rent Collection Record",
        url: "/RENT_Rent_Collection_Record",
      }
,      {
        title: "Rental Income Property Manager Report",
        url: "/RENT_Property_Manager_Report",
      }
,      {
        title: "Rental Income Tenant Profile",
        url: "/RENT_Tenant_Profile",
      }
,      {
        title: "Rental Income Rent Roll Snapshot",
        url: "/RENT_Rent_Roll_Snapshot",
      }
,      {
        title: "Rental Income Operating Expense Record",
        url: "/RENT_Operating_Expense_Record",
      }
,      {
        title: "Rental Income Reserve Account Record",
        url: "/RENT_Reserve_Account_Record",
      }
,      {
        title: "Rental Income Delinquency and Vacancy Record",
        url: "/RENT_Delinquency_Vacancy_Record",
      }

	]
  }
,  {
    title: "05 FINANCE ESCROW DISTRIBUTION REPORTING",
    submenu: [
	      {
        title: "Rental Income Token Escrow Release Package",
        url: "/RENT_Escrow_Release_Package",
      }
,      {
        title: "Rental Income Token Investor Report",
        url: "/RENT_Investor_Report",
      }
,      {
        title: "Rental Income Token Distribution Calculation",
        url: "/RENT_Distribution_Calculation",
      }
,      {
        title: "Rental Income Distribution Approval",
        url: "/RENT_Distribution_Approval",
      }

	]
  }
,  {
    title: "06 ASSET MANAGER LIFECYCLE EXIT",
    submenu: [
	      {
        title: "Rental Income Token Lifecycle Milestone",
        url: "/RENT_Lifecycle_Milestone",
      }
,      {
        title: "Rental Income Token Exit Strategy",
        url: "/RENT_Exit_Strategy",
      }

	]
  }

	]
  }
,  {
    title: "REVENUE SHARE",
    submenu: [
	  {
    title: "01 ASSET OWNER SPONSOR REVENUE SETUP",
    submenu: [
	      {
        title: "Revenue Share Asset Profile",
        url: "/REVSHARE_Asset_Profile",
      }
,      {
        title: "Revenue Share Revenue Source",
        url: "/REVSHARE_Revenue_Source",
      }

	]
  }
,  {
    title: "02 OFFERING LEGAL COMPLIANCE READINESS",
    submenu: [
	      {
        title: "Revenue Share Token Offering",
        url: "/REVSHARE_Token_Offering",
      }
,      {
        title: "Revenue Share Token Token Class",
        url: "/REVSHARE_Token_Class",
      }
,      {
        title: "Revenue Share Token Token Economics",
        url: "/REVSHARE_Token_Economics",
      }
,      {
        title: "Revenue Share Token Legal Rights Matrix",
        url: "/REVSHARE_Legal_Rights_Matrix",
      }
,      {
        title: "Revenue Share Token Risk Score",
        url: "/REVSHARE_Risk_Score",
      }

	]
  }
,  {
    title: "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
    submenu: [
	      {
        title: "Revenue Share Token Subscription Order",
        url: "/REVSHARE_Subscription_Order",
      }
,      {
        title: "Revenue Share Token Token Ledger",
        url: "/REVSHARE_Token_Ledger",
      }

	]
  }
,  {
    title: "04 REVENUE OPERATOR VERIFIER OPERATIONS",
    submenu: [
	      {
        title: "Revenue Share Token Independent Inspection Report",
        url: "/REVSHARE_Independent_Inspection_Report",
      }
,      {
        title: "Revenue Share Revenue Verification Report",
        url: "/REVSHARE_Revenue_Verification_Report",
      }

	]
  }
,  {
    title: "05 FINANCE ESCROW DISTRIBUTION REPORTING",
    submenu: [
	      {
        title: "Revenue Share Token Escrow Release Package",
        url: "/REVSHARE_Escrow_Release_Package",
      }
,      {
        title: "Revenue Share Token Distribution Calculation",
        url: "/REVSHARE_Distribution_Calculation",
      }
,      {
        title: "Revenue Share Token Investor Report",
        url: "/REVSHARE_Investor_Report",
      }

	]
  }
,  {
    title: "06 SPONSOR GOVERNANCE LIFECYCLE EXIT",
    submenu: [
	      {
        title: "Revenue Share Token Lifecycle Milestone",
        url: "/REVSHARE_Lifecycle_Milestone",
      }
,      {
        title: "Revenue Share Token Exit Strategy",
        url: "/REVSHARE_Exit_Strategy",
      }

	]
  }

	]
  }
,  {
    title: "SALE PROFIT",
    submenu: [
	  {
    title: "01 ASSET OWNER SPONSOR ASSET EXIT SETUP",
    submenu: [
	      {
        title: "Sale Profit Asset Profile",
        url: "/SALEPROFIT_Asset_Profile",
      }
,      {
        title: "Sale Profit Token Exit Strategy",
        url: "/SALEPROFIT_Exit_Strategy",
      }

	]
  }
,  {
    title: "02 OFFERING LEGAL COMPLIANCE READINESS",
    submenu: [
	      {
        title: "Sale Profit Token Offering",
        url: "/SALEPROFIT_Token_Offering",
      }
,      {
        title: "Sale Profit Token Token Class",
        url: "/SALEPROFIT_Token_Class",
      }
,      {
        title: "Sale Profit Token Token Economics",
        url: "/SALEPROFIT_Token_Economics",
      }
,      {
        title: "Sale Profit Token Legal Rights Matrix",
        url: "/SALEPROFIT_Legal_Rights_Matrix",
      }
,      {
        title: "Sale Profit Token Risk Score",
        url: "/SALEPROFIT_Risk_Score",
      }
,      {
        title: "Sale Profit Token Independent Inspection Report",
        url: "/SALEPROFIT_Independent_Inspection_Report",
      }

	]
  }
,  {
    title: "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
    submenu: [
	      {
        title: "Sale Profit Token Subscription Order",
        url: "/SALEPROFIT_Subscription_Order",
      }
,      {
        title: "Sale Profit Token Token Ledger",
        url: "/SALEPROFIT_Token_Ledger",
      }

	]
  }
,  {
    title: "04 ASSET MANAGER SALE PROCESS EXECUTION",
    submenu: [
	      {
        title: "Sale Profit Token Lifecycle Milestone",
        url: "/SALEPROFIT_Lifecycle_Milestone",
      }
,      {
        title: "Sale Profit Sale Process",
        url: "/SALEPROFIT_Sale_Process",
      }

	]
  }
,  {
    title: "05 FINANCE ESCROW PROFIT DISTRIBUTION",
    submenu: [
	      {
        title: "Sale Profit Waterfall",
        url: "/SALEPROFIT_Profit_Waterfall",
      }
,      {
        title: "Sale Profit Token Distribution Calculation",
        url: "/SALEPROFIT_Distribution_Calculation",
      }
,      {
        title: "Sale Profit Token Escrow Release Package",
        url: "/SALEPROFIT_Escrow_Release_Package",
      }

	]
  }
,  {
    title: "06 INVESTOR RELATIONS TAX CLOSEOUT",
    submenu: [
	      {
        title: "Sale Profit Token Investor Report",
        url: "/SALEPROFIT_Investor_Report",
      }

	]
  }

	]
  }
,  {
    title: "EQUITY APPRECIATION",
    submenu: [
	  {
    title: "01 ASSET OWNER SPONSOR NAV ASSET SETUP",
    submenu: [
	      {
        title: "Equity Appreciation Asset Profile",
        url: "/EQAPP_Asset_Profile",
      }

	]
  }
,  {
    title: "02 OFFERING NAV LEGAL COMPLIANCE READINESS",
    submenu: [
	      {
        title: "Equity Appreciation Token Offering",
        url: "/EQAPP_Token_Offering",
      }
,      {
        title: "Equity Appreciation Token Token Class",
        url: "/EQAPP_Token_Class",
      }
,      {
        title: "Equity Appreciation Token Token Economics",
        url: "/EQAPP_Token_Economics",
      }
,      {
        title: "Equity Appreciation Token Legal Rights Matrix",
        url: "/EQAPP_Legal_Rights_Matrix",
      }
,      {
        title: "Equity Appreciation NAV Valuation Report",
        url: "/EQAPP_NAV_Valuation_Report",
      }
,      {
        title: "Equity Appreciation Calculation",
        url: "/EQAPP_Appreciation_Calculation",
      }
,      {
        title: "Equity Appreciation Token Risk Score",
        url: "/EQAPP_Risk_Score",
      }
,      {
        title: "Equity Appreciation Token Independent Inspection Report",
        url: "/EQAPP_Independent_Inspection_Report",
      }

	]
  }
,  {
    title: "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
    submenu: [
	      {
        title: "Equity Appreciation Token Subscription Order",
        url: "/EQAPP_Subscription_Order",
      }
,      {
        title: "Equity Appreciation Token Token Ledger",
        url: "/EQAPP_Token_Ledger",
      }

	]
  }
,  {
    title: "04 ASSET MANAGER NAV LIFECYCLE MONITORING",
    submenu: [
	      {
        title: "Equity Appreciation Token Lifecycle Milestone",
        url: "/EQAPP_Lifecycle_Milestone",
      }

	]
  }
,  {
    title: "05 FINANCE ESCROW APPRECIATION DISTRIBUTION",
    submenu: [
	      {
        title: "Equity Appreciation Token Distribution Calculation",
        url: "/EQAPP_Distribution_Calculation",
      }
,      {
        title: "Equity Appreciation Token Escrow Release Package",
        url: "/EQAPP_Escrow_Release_Package",
      }

	]
  }
,  {
    title: "06 INVESTOR RELATIONS TAX EXIT",
    submenu: [
	      {
        title: "Equity Appreciation Token Investor Report",
        url: "/EQAPP_Investor_Report",
      }
,      {
        title: "Equity Appreciation Token Exit Strategy",
        url: "/EQAPP_Exit_Strategy",
      }

	]
  }

	]
  }
,  {
    title: "PREFERRED EQUITY",
    submenu: [
	  {
    title: "01 ASSET OWNER SPONSOR PREFERRED EQUITY SETUP",
    submenu: [
	      {
        title: "Preferred Equity Asset Profile",
        url: "/PREFEQ_Asset_Profile",
      }
,      {
        title: "Preferred Equity Token Offering",
        url: "/PREFEQ_Token_Offering",
      }

	]
  }
,  {
    title: "02 OFFERING LEGAL PREFERRED WATERFALL READINESS",
    submenu: [
	      {
        title: "Preferred Equity Token Token Class",
        url: "/PREFEQ_Token_Class",
      }
,      {
        title: "Preferred Equity Token Token Economics",
        url: "/PREFEQ_Token_Economics",
      }
,      {
        title: "Preferred Equity Return Waterfall",
        url: "/PREFEQ_Preferred_Return_Waterfall",
      }
,      {
        title: "Preferred Equity Token Legal Rights Matrix",
        url: "/PREFEQ_Legal_Rights_Matrix",
      }
,      {
        title: "Preferred Equity Token Risk Score",
        url: "/PREFEQ_Risk_Score",
      }

	]
  }
,  {
    title: "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
    submenu: [
	      {
        title: "Preferred Equity Token Subscription Order",
        url: "/PREFEQ_Subscription_Order",
      }
,      {
        title: "Preferred Equity Token Token Ledger",
        url: "/PREFEQ_Token_Ledger",
      }
,      {
        title: "Preferred Equity Capital Account",
        url: "/PREFEQ_Capital_Account",
      }

	]
  }
,  {
    title: "04 INSPECTION ESCROW CAPITAL RELEASE",
    submenu: [
	      {
        title: "Preferred Equity Token Independent Inspection Report",
        url: "/PREFEQ_Independent_Inspection_Report",
      }
,      {
        title: "Preferred Equity Token Escrow Release Package",
        url: "/PREFEQ_Escrow_Release_Package",
      }

	]
  }
,  {
    title: "05 FINANCE PREFERRED RETURN DISTRIBUTION",
    submenu: [
	      {
        title: "Preferred Equity Token Distribution Calculation",
        url: "/PREFEQ_Distribution_Calculation",
      }

	]
  }
,  {
    title: "06 INVESTOR RELATIONS TAX REPORTING",
    submenu: [
	      {
        title: "Preferred Equity Token Investor Report",
        url: "/PREFEQ_Investor_Report",
      }

	]
  }
,  {
    title: "07 ASSET MANAGER LIFECYCLE EXIT",
    submenu: [
	      {
        title: "Preferred Equity Token Lifecycle Milestone",
        url: "/PREFEQ_Lifecycle_Milestone",
      }
,      {
        title: "Preferred Equity Token Exit Strategy",
        url: "/PREFEQ_Exit_Strategy",
      }

	]
  }

	]
  }
,  {
    title: "COMMON EQUITY",
    submenu: [
	  {
    title: "01 ASSET OWNER SPONSOR EQUITY SETUP",
    submenu: [
	      {
        title: "Common Equity Asset Profile",
        url: "/COMEQ_Asset_Profile",
      }

	]
  }
,  {
    title: "02 OFFERING LEGAL COMPLIANCE READINESS",
    submenu: [
	      {
        title: "Common Equity Token Offering",
        url: "/COMEQ_Token_Offering",
      }
,      {
        title: "Common Equity Token Token Class",
        url: "/COMEQ_Token_Class",
      }
,      {
        title: "Common Equity Token Token Economics",
        url: "/COMEQ_Token_Economics",
      }
,      {
        title: "Common Equity Token Legal Rights Matrix",
        url: "/COMEQ_Legal_Rights_Matrix",
      }
,      {
        title: "Common Equity Token Risk Score",
        url: "/COMEQ_Risk_Score",
      }

	]
  }
,  {
    title: "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
    submenu: [
	      {
        title: "Common Equity Token Subscription Order",
        url: "/COMEQ_Subscription_Order",
      }
,      {
        title: "Common Equity Token Token Ledger",
        url: "/COMEQ_Token_Ledger",
      }
,      {
        title: "Common Equity Cap Table",
        url: "/COMEQ_Cap_Table",
      }

	]
  }
,  {
    title: "04 EQUITY OWNERSHIP GOVERNANCE MANAGEMENT",
    submenu: [
	      {
        title: "Common Equity Token Lifecycle Milestone",
        url: "/COMEQ_Lifecycle_Milestone",
      }
,      {
        title: "Common Equity Token Independent Inspection Report",
        url: "/COMEQ_Independent_Inspection_Report",
      }

	]
  }
,  {
    title: "05 FINANCE ESCROW DISTRIBUTION REPORTING",
    submenu: [
	      {
        title: "Common Equity Distribution Waterfall",
        url: "/COMEQ_Equity_Distribution_Waterfall",
      }
,      {
        title: "Common Equity Token Distribution Calculation",
        url: "/COMEQ_Distribution_Calculation",
      }
,      {
        title: "Common Equity Token Escrow Release Package",
        url: "/COMEQ_Escrow_Release_Package",
      }
,      {
        title: "Common Equity Token Investor Report",
        url: "/COMEQ_Investor_Report",
      }

	]
  }
,  {
    title: "06 ASSET MANAGER LIFECYCLE EXIT",
    submenu: [
	      {
        title: "Common Equity Token Exit Strategy",
        url: "/COMEQ_Exit_Strategy",
      }

	]
  }

	]
  }
,  {
    title: "DEBT NOTE",
    submenu: [
	  {
    title: "01 ASSET OWNER SPONSOR COLLATERAL SETUP",
    submenu: [
	      {
        title: "Debt Note Collateral Asset Profile",
        url: "/DEBT_Asset_Profile",
      }
,      {
        title: "Debt Note Token Offering",
        url: "/DEBT_Token_Offering",
      }
,      {
        title: "Debt Note Terms",
        url: "/DEBT_Note_Terms",
      }

	]
  }
,  {
    title: "02 DEBT STRUCTURING LEGAL RISK READINESS",
    submenu: [
	      {
        title: "Debt Note Token Token Class",
        url: "/DEBT_Token_Class",
      }
,      {
        title: "Debt Note Token Token Economics",
        url: "/DEBT_Token_Economics",
      }
,      {
        title: "Debt Payment Schedule",
        url: "/DEBT_Payment_Schedule",
      }
,      {
        title: "Debt Note Token Legal Rights Matrix",
        url: "/DEBT_Legal_Rights_Matrix",
      }
,      {
        title: "Debt Note Token Risk Score",
        url: "/DEBT_Risk_Score",
      }
,      {
        title: "Debt Note Token Independent Inspection Report",
        url: "/DEBT_Independent_Inspection_Report",
      }

	]
  }
,  {
    title: "03 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
    submenu: [
	      {
        title: "Debt Note Token Subscription Order",
        url: "/DEBT_Subscription_Order",
      }
,      {
        title: "Debt Note Token Token Ledger",
        url: "/DEBT_Token_Ledger",
      }

	]
  }
,  {
    title: "04 DEBT SERVICING INTEREST PAYMENT MANAGEMENT",
    submenu: [
	      {
        title: "Debt Interest Accrual",
        url: "/DEBT_Interest_Accrual",
      }
,      {
        title: "Debt Note Token Distribution Calculation",
        url: "/DEBT_Distribution_Calculation",
      }

	]
  }
,  {
    title: "05 FINANCE ESCROW INVESTOR REPORTING",
    submenu: [
	      {
        title: "Debt Note Token Escrow Release Package",
        url: "/DEBT_Escrow_Release_Package",
      }
,      {
        title: "Debt Note Token Investor Report",
        url: "/DEBT_Investor_Report",
      }

	]
  }
,  {
    title: "06 LIFECYCLE DEFAULT MATURITY EXIT",
    submenu: [
	      {
        title: "Debt Note Token Lifecycle Milestone",
        url: "/DEBT_Lifecycle_Milestone",
      }
,      {
        title: "Debt Note Token Exit Strategy",
        url: "/DEBT_Exit_Strategy",
      }

	]
  }

	]
  }
,  {
    title: "HYBRID",
    submenu: [
	  {
    title: "01 ASSET OWNER SPONSOR HYBRID ASSET SETUP",
    submenu: [
	      {
        title: "Hybrid Asset Profile",
        url: "/HYBRID_Asset_Profile",
      }

	]
  }
,  {
    title: "02 OFFERING STRUCTURING HYBRID MODEL SETUP",
    submenu: [
	      {
        title: "Hybrid Token Offering",
        url: "/HYBRID_Token_Offering",
      }
,      {
        title: "Hybrid Component Mix",
        url: "/HYBRID_Component_Mix",
      }
,      {
        title: "Hybrid Token Token Class",
        url: "/HYBRID_Token_Class",
      }
,      {
        title: "Hybrid Token Token Economics",
        url: "/HYBRID_Token_Economics",
      }

	]
  }
,  {
    title: "03 LEGAL RISK ESCROW READINESS",
    submenu: [
	      {
        title: "Hybrid Token Legal Rights Matrix",
        url: "/HYBRID_Legal_Rights_Matrix",
      }
,      {
        title: "Hybrid Token Risk Score",
        url: "/HYBRID_Risk_Score",
      }
,      {
        title: "Hybrid Token Independent Inspection Report",
        url: "/HYBRID_Independent_Inspection_Report",
      }

	]
  }
,  {
    title: "04 INVESTOR SUBSCRIPTION TOKEN ISSUANCE",
    submenu: [
	      {
        title: "Hybrid Token Subscription Order",
        url: "/HYBRID_Subscription_Order",
      }
,      {
        title: "Hybrid Token Token Ledger",
        url: "/HYBRID_Token_Ledger",
      }

	]
  }
,  {
    title: "05 FINANCE WATERFALL DISTRIBUTION REPORTING",
    submenu: [
	      {
        title: "Hybrid Token Distribution Calculation",
        url: "/HYBRID_Distribution_Calculation",
      }
,      {
        title: "Hybrid Combined Distribution Waterfall",
        url: "/HYBRID_Combined_Distribution_Waterfall",
      }
,      {
        title: "Hybrid Token Escrow Release Package",
        url: "/HYBRID_Escrow_Release_Package",
      }
,      {
        title: "Hybrid Token Investor Report",
        url: "/HYBRID_Investor_Report",
      }

	]
  }
,  {
    title: "06 ASSET MANAGER LIFECYCLE EXIT",
    submenu: [
	      {
        title: "Hybrid Token Lifecycle Milestone",
        url: "/HYBRID_Lifecycle_Milestone",
      }
,      {
        title: "Hybrid Token Exit Strategy",
        url: "/HYBRID_Exit_Strategy",
      }

	]
  }

	]
  }
,  {
    title: "PRE AUCTION POOL",
    submenu: [
	  {
    title: "01 SPONSOR AUCTION OPPORTUNITY INTAKE",
    submenu: [
	      {
        title: "Pre-Auction Auction Opportunity",
        url: "/PREAUCT_Auction_Opportunity",
      }
,      {
        title: "Pre-Auction Source Verification",
        url: "/PREAUCT_Auction_Source_Verification",
      }

	]
  }
,  {
    title: "02 DUE DILIGENCE TITLE RISK MAX BID",
    submenu: [
	      {
        title: "Pre-Auction Due Diligence",
        url: "/PREAUCT_Pre_Auction_Due_Diligence",
      }
,      {
        title: "Pre-Auction Title and Lien Precheck",
        url: "/PREAUCT_Title_Lien_Precheck",
      }
,      {
        title: "Pre-Auction Risk Assessment",
        url: "/PREAUCT_Auction_Risk_Assessment",
      }
,      {
        title: "Pre-Auction Maximum Bid Analysis",
        url: "/PREAUCT_Max_Bid_Analysis",
      }

	]
  }
,  {
    title: "03 POOL STRUCTURING ESCROW COMPLIANCE",
    submenu: [
	      {
        title: "Pre-Auction Pool",
        url: "/PREAUCT_Pre_Auction_Pool",
      }
,      {
        title: "Pre-Auction Pool Escrow Setup",
        url: "/PREAUCT_Pool_Escrow_Setup",
      }
,      {
        title: "Pre-Auction Compliance Review",
        url: "/PREAUCT_Compliance_Review",
      }

	]
  }
,  {
    title: "04 INVESTOR PLEDGE ESCROW FUNDING",
    submenu: [
	      {
        title: "Pre-Auction Investor Pledge",
        url: "/PREAUCT_Investor_Pledge",
      }
,      {
        title: "Pre-Auction Investor Risk Acknowledgment",
        url: "/PREAUCT_Investor_Risk_Acknowledgment",
      }

	]
  }
,  {
    title: "05 BID AUTHORIZATION SUBMISSION RESULT",
    submenu: [
	      {
        title: "Pre-Auction Bid Authorization",
        url: "/PREAUCT_Bid_Authorization",
      }
,      {
        title: "Pre-Auction Bid Submission",
        url: "/PREAUCT_Auction_Bid_Submission",
      }
,      {
        title: "Pre-Auction Auction Result",
        url: "/PREAUCT_Auction_Result",
      }

	]
  }
,  {
    title: "06 REFUND TRANSITION REPORTING CLOSEOUT",
    submenu: [
	      {
        title: "Pre-Auction Refund Process",
        url: "/PREAUCT_Refund_Process",
      }
,      {
        title: "Pre-Auction Winning Bid Transition",
        url: "/PREAUCT_Winning_Bid_Transition",
      }
,      {
        title: "Pre-Auction Investor Update Report",
        url: "/PREAUCT_Investor_Update_Report",
      }
,      {
        title: "Pre-Auction Final Pool Closeout",
        url: "/PREAUCT_Final_Pool_Closeout",
      }

	]
  }

	]
  }
,  {
    title: "POST AUCTION",
    submenu: [
	  {
    title: "01 SPONSOR AUCTION RESULT INTAKE CLOSING",
    submenu: [
	      {
        title: "Post-Auction Result Intake",
        url: "/POSTAUCT_Auction_Result_Intake",
      }
,      {
        title: "Post-Auction Acquisition Closing",
        url: "/POSTAUCT_Acquisition_Closing",
      }

	]
  }
,  {
    title: "02 LEGAL TITLE LIEN REDEMPTION CLEARANCE",
    submenu: [
	      {
        title: "Post-Auction Title Cure",
        url: "/POSTAUCT_Post_Auction_Title_Cure",
      }
,      {
        title: "Post-Auction Lien and Tax Clearance",
        url: "/POSTAUCT_Lien_Tax_Clearance",
      }
,      {
        title: "Post-Auction Redemption Period Review",
        url: "/POSTAUCT_Redemption_Period_Review",
      }

	]
  }
,  {
    title: "03 PROPERTY CONTROL CONDITION REHAB APPRAISAL",
    submenu: [
	      {
        title: "Post-Auction Occupancy and Eviction Status",
        url: "/POSTAUCT_Occupancy_Eviction_Status",
      }
,      {
        title: "Post-Auction Property Condition Assessment",
        url: "/POSTAUCT_Property_Condition_Assessment",
      }
,      {
        title: "Post-Auction Rehab Budget",
        url: "/POSTAUCT_Rehab_Budget",
      }
,      {
        title: "Post-Auction Appraisal",
        url: "/POSTAUCT_Post_Auction_Appraisal",
      }

	]
  }
,  {
    title: "04 SPV TRANSFER READINESS RISK",
    submenu: [
	      {
        title: "Post-Auction SPV Asset Transfer",
        url: "/POSTAUCT_SPV_Asset_Transfer",
      }
,      {
        title: "Post-Auction Tokenization Readiness Checklist",
        url: "/POSTAUCT_Tokenization_Readiness_Checklist",
      }
,      {
        title: "Post-Auction Risk Score",
        url: "/POSTAUCT_Post_Auction_Risk_Score",
      }

	]
  }
,  {
    title: "05 OFFERING DISCLOSURE COMPLIANCE APPROVAL",
    submenu: [
	      {
        title: "Post-Auction Offering Readiness",
        url: "/POSTAUCT_Offering_Readiness",
      }
,      {
        title: "Post-Auction Investor Disclosure Package",
        url: "/POSTAUCT_Investor_Disclosure_Package",
      }
,      {
        title: "Post-Auction Final Tokenization Approval",
        url: "/POSTAUCT_Final_Tokenization_Approval",
      }

	]
  }
,  {
    title: "06 INVESTOR RELATIONS UPDATE REPORTING",
    submenu: [
	      {
        title: "Post-Auction Investor Update Report",
        url: "/POSTAUCT_Investor_Update_Report",
      }

	]
  }

	]
  }

  ,{
    title: "Subscription",
    url: "/Subscription",
  },
  {
    title: "LogOut",
    url: "/login_logout",
  }
];

export const publicMenuItems = [
  {
    title: "About",
    url: "/about",
  },
  {
    title: "Contact",
    url: "/contact",
  },
  {
    title: "Services",
    url: "/services",
  },
  {
    title: "Subscription",
    url: "/Subscription",
  },
  {
    title: "Login",
    url: "/login_logout",
  }
];


